import gql from "graphql-tag";

export const TRADE_DISCOUNTS_QUERY = gql`
  query TradeDiscountQuery($organisation: ID!) {
    tradeDiscounts(organisation: $organisation) {
      id
      displayName
      code
      value
      available
      used
      validTo
      supportedTestNames
      description
    }
  }
`;
